class DeliverySaverService {
    constructor(RestangularV3) {
        this.api = RestangularV3.one('deliverysaver');
    }

    getEligibility() {
        return this.api.one('eligibility').get();
    }

    listPlans() {
        return this.api.one('plans').get();
    }

    getPlan(id) {
        return this.api.one(`plans/${id}`).get();
    }

    getPayments() {
        return this.api.one('payments').get();
    }

    getDiscounts() {
        return this.api.one('discounts').get();
    }

    subscribe(planId, paymentInstrument) {
        return this.api.post('subscription', {
            planId,
            paymentInstrumentId: paymentInstrument.paymentInstrumentId,
            stepUpToken: paymentInstrument.stepUpToken,
        });
    }

    getSubscription() {
        return this.api.one('subscription').get();
    }

    cancelSubscription() {
        return this.api.post('subscription/cancel');
    }

    updatePaymentInstrument(paymentInstrument) {
        return this.api.post('subscription/paymentinstrument', {
            paymentInstrumentId: paymentInstrument.paymentInstrumentId,
            stepUpToken: paymentInstrument.stepUpToken,
        });
    }

    UpdateCardExpiryDate(paymentInstrument) {
        return this.api.post('subscription/cardexpirydate', {
            paymentInstrumentId: paymentInstrument.paymentInstrumentId,
            cardExpiryYear: paymentInstrument.cardExpiryYear,
            cardExpiryMonth: paymentInstrument.cardExpiryMonth,
        });
    }

    retryPayment() {
        return this.api.post('subscription/retrypayment');
    }
}

DeliverySaverService.$inject = ['RestangularV3'];

module.exports = { DeliverySaverService };



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver.service.js